import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Button } from 'reactstrap';
import Navigation from '../../components/Navigation/Navigation';
import IncomeFinanceFields from '../../components/Fields/IncomeFinanceFields';
import { IncomeFinancesValidator } from '../../utils/Validators';
import withBackgroundImage from '../../HOC/withBackgroundImage';
import debounce from 'debounce';

import { updateIncomeExpenses } from '../../actions/incomeExpensesAction';


class IncomeFinances extends Component {
    constructor(props) {
        super(props);

        this.validator = IncomeFinancesValidator();

        this.state = {            
            householdincome: this.props.householdincome === undefined ? "" : this.props.householdincome,
            investmentincome: this.props.investmentincome === undefined ? "" : this.props.investmentincome,
            validation: this.validator.valid()
        }

        this.onClickForward = this.onClickForward.bind(this);
        this.onClickBackward = this.onClickBackward.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.validateField = this.validateField.bind(this);
    }
    onClickForward(event) {
        event.preventDefault();        

        this.setState({ validation: this.validator.validate(this.state) }, () => {
            if (this.state.validation.isValid) {
                
                var elem = document.getElementById("errorBox");
                var cardType = this.props.card.cpc;
                const minHousehold = (cardType === 'VIR') ? 100000 : 200000;
                const minInvestable = (cardType === 'VIR') ? 250000 : 400000;                
                var householdIncome = Number.parseFloat(this.state.householdincome);
                var investableFunds = Number.parseFloat(this.state.investmentincome);   
                                
                if ((householdIncome >= minHousehold) || (investableFunds >= minInvestable)) {                    
                    this.props.history.replace('/AuthorizedUsers');
                } else {
                    elem.style.display = "block";        
                }
            }
        });
    }    
    onClickBackward() {
        this.props.history.replace('/IncomeExpenses');
    }
    handleChange(event) {
        var elem = document.getElementById("errorBox");

        if (elem.style.display === "block") {
            elem.style.display = "none";    
        }        

        this.setState({
            validation: { ...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name) },
            [event.target.name]: event.target.value
        }, () => {
            this.updateIncomeExpenses();
        });
    }
    validateField(event) {
        this.setState({
            validation: { ...this.state.validation, [event.target.name]: this.validator.validateField(event.target.name, event.target.value) }
        });
    }
    updateIncomeExpenses = debounce(() => {
        this.props.updateIncomeExpenses({ householdincome: this.state.householdincome, investmentincome: this.state.investmentincome });
    }, 1000);
    render() {
        let householdIncome;
        let investableFunds;
        let cardType = this.props.card.cpc;

        householdIncome = (cardType === 'VIR') ? "100,000" : "200,000";
        investableFunds = (cardType === 'VIR') ? "250,000" : "400,000";

        return (
            <div>
                <h1>Tell us more about your finances</h1>
                <p style={{fontStyle:'italic'}}>
                    Please enter your annual household income or investable funds.
                    <br />
                    To be eligible for an {this.props.card.name} card, you must meet one of the following:
                    <ul>
                        <li>Minimum annual household income of ${householdIncome}</li>
                        <li>Investable funds of ${investableFunds} or more</li>
                    </ul>
                </p>
                <p id="errorBox" style={{ display: 'none', fontStyle:'italic', fontWeight:'bold'}}>
                    Based on the information provided, you do not meet the qualifications for this card.
                    Please click on the Review Products button below to check out our other credit card offerings.
                </p>
                <Form>                    
                    <IncomeFinanceFields handleChange={this.handleChange} validateField={this.validateField} {...this.state} />
                    <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />      
                    <div className="buttons-container">
                        <Button  style={{textDecoration:'none'}} href="https://www.vancity.com/CreditCards/">Review Products</Button>
                    </div>
                </Form>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    ...state.incomeExpenses,
    card: state.card
});

const mapDispatchToProps = dispatch => ({
    updateIncomeExpenses: (incomeExpenses) => dispatch(updateIncomeExpenses(incomeExpenses))
});

export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("income-expenses")(IncomeFinances));


// WEBPACK FOOTER //
// ./src/containers/IncomeExpenses/IncomeFinances.js